import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-formato-cotizacion',
  templateUrl: './formato-cotizacion.component.html',
  styleUrls: ['./formato-cotizacion.component.css']
})
export class FormatoCotizacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
